import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";
import BaseServiceApi from "BaseServiceApi";

export default class AnnotationsUndoRequest extends BaseServiceRequest {
    constructor(annotIds) {
        super();
        super.addRequestUri("annotations.pb");
        const listProto = BaseServiceApi.rayData["AnnotationListData"];
        const listWrapProto = new listProto();

        let createAnnotData = undefined;
        const annotProto = BaseServiceApi.rayData["AnnotationData"];

        annotIds.map((id) => {
            createAnnotData = new annotProto();
            createAnnotData.annotationID = id;
            listWrapProto.annotationData.push(createAnnotData);
        });
        
        const reqcontent = listWrapProto.encode();
        super.setContent(reqcontent);
    }
    getMethod() {
        return HttpMethodType.PUT;
    }

    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return "Response";
    }

}
